<template>
    <div class="search-communicate grid xs-grid-cols-1 gap-3">
        <div class="grid xs-grid-cols-1 gap-1">
            <div>
                <span class="text-bold">Commute</span>
            </div>
            <mvtInputGeo class="small" btnclass="" v-model="geoInfo" placeholder="Enter commute address" :key="geoInfo.text ===''" :options="{types:['address']}" />
        </div>
        <div class="grid xs-grid-cols-1 gap-1">
            <div class="text-bold">Expand Search Area</div>
            <mvtRadio class="small buttons flex left wrap toggle" :data="commuteData" v-model="commuteRadius" />
        </div>
    </div>
</template>
<script src="./search-communicate.js"></script>